<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-md-12 container-header">reports
        <div class="icon-information"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ul class="status-menu">
          <li class="status-menu-item" @click="navigateTab(consts.reportType.upcoming)"
              :class="(tableType == consts.reportType.upcoming) ? 'selected' : null">
            upcoming
          </li>
          <li class="status-menu-item" @click="navigateTab(consts.reportType.completed)"
              :class="(tableType == consts.reportType.completed) ? 'selected' : null">
            completed
          </li>
          <!--<li class="status-menu-item" @click="tableType = consts.reportType.satisfaction"
              :class="(tableType == consts.reportType.satisfaction) ? 'selected' : null">
            satisfaction
          </li>-->
        </ul>
      </div>
    </div>
    <div class="row status-message">
      <div class="col-md-12">
        {{consts.reportMessage[tableType]}}
      </div>
    </div>
    <div class="">
      <SubHeaderManageReports :pagingObj="pagingObj" :eventStatus="tableType" :sliderValue="sliderValue"
                              :textSearch="textSearch"
                              @TEXT_SEARCH_CHANGE="handleTextSearchChange"
                              @CHANGE_FILTER_OPTION="handleChangeDataFilter"
                              @SLIDER_CHANGE_VALUE="handleSliderChangeValue"></SubHeaderManageReports>
    </div>
    <div>
      <router-view :reportType="tableType" :dateOut="sliderValue" :filterBy="dataFilter" :textSearch="textSearch" ></router-view>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import DataTable from '../../../components/datatable/DataTable';
  import consts from '../../../_consts';
  import Icon from 'vue-awesome/components/Icon';
  import SubHeaderManageReports from '../../subHeaders/SubHeaderManageReports';
  import EventChart from '../reports/EventChart';
  import DtPaging from '../../../components/datatable/DtPaging';
  import EventBarChart from '../reports/EventBarChart';
  import EventCompletedReportCard from '../../commons/EventCompletedReportCard';
  import routerConstants from '@/router/constants';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-report-main-view',
    components: {
      Icon,
      DataTable,
      SubHeaderManageReports,
      EventChart,
      DtPaging,
      EventBarChart,
      EventCompletedReportCard
    },
    props: {},
    data () {
      return {
        message: consts.reportMessage.upcoming,
        tableType: consts.reportType.upcoming,
        consts: consts,
        sliderValue: ['0', '0'],
        dataFilter: ['dateTime'],
        textSearch: '',
        pagingObj: {
          currentPage: 1,
          itemsPerPage: 25,
          sortType: 'firstName',
          sortReverse: false,
          totalItems: 0
        },
        wrapperChart: {
          row1: {
            chartDataTable: ['Overall', 'Professionalism', 'Willingness to Recommend', 'Communication', 'Preparedness'],
            chartColors: ['#FF4040', '#A60000', '#FF7400', '#A64B00', '#CD0074']
          },
          row2: {
            chartDataTable: ['On-Time Start and Finish', 'Check-in Process', 'Professionalism - Coach', ' Professionalism - Screener', 'Professionalism - Lead'],
            chartColors: ['#E667AF', '#00CC00', '#008500', '#0F4DA8', '#052F6D']
          },
          row3: {
            chartDataTable: ['Scheduler Tool', 'Reporting', 'Participant Feedback', 'Data Transfer', 'Event Breakdown'],
            chartColors: ['#B1F100', '#D4F870', '#AF3BD4', '#E9FB00', '#F3FD72']
          }
        }
      };
    },
    computed: {
      ...mapGetters({
        getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
      })
    },
    methods: {
      handleTextSearchChange (textSearch) {
        this.textSearch = textSearch;
        // this.reloadDataWithChangeFilterData();
      },
      handleSliderChangeValue (data) {
        this.sliderValue = data;
      },
      handleChangeDataFilter (data) {
        this.dataFilter = data;
      },
      navigateTab (tab) {
        this.tableType = tab;
        let reportChildRouterName = routerConstants.clientDashboard.children.reports.children;
        let routerName = tab === consts.reportType.upcoming ? reportChildRouterName.upcoming.name : reportChildRouterName.completed.name;
        this.$router.push({
          name: routerName,
          params: {
            clientId: this.$route.params.clientId
          }
        })
      },
      ...mapActions({
      })
    },
    created () {
      this.tableType = routerConstants.clientDashboard.children.reports.children.upcoming.name === this.$route.name ? consts.reportType.upcoming : consts.reportType.completed;
    }
  };
</script>

<style lang="less" scoped="">
  @import '../../../styles/variables.less';

  .wrapper {
    padding: 24px 16px 24px 16px;
    .container-header {
      color: @black-3;
      font-family: @font-family-main;
      font-size: 32px;
      font-weight: 800;
      letter-spacing: -1px;
      line-height: 40px;
      text-transform: uppercase;
    }
    .icon-information {
      display: inline-block;
      margin: 0 8px;
      width: 24px;
      height: 24px;
      color: @grey-3;
      background-color: @light-blue;
      -webkit-mask: url('../../../../static/img/status-information.svg') no-repeat center;
      mask: url('../../../../static/img/status-information.svg') no-repeat center;
      background: url('../../../../static/img/status-information-blue.svg');
    }

    .status-menu {
      color: #B9B9B9;
      font-family: "Open Sans", sans-serif;
      font-size: 12px;
      font-weight: 600;
      line-height: 17px;
      list-style: none;
      -webkit-padding-start: 0;
      margin-top: 18px;
      li.status-menu-item {
        display: inline;
        margin-right: 49px;
        text-transform: capitalize;
        padding-bottom: 10px;
        &:hover, &.selected {
          color: #00A4D6;
          border-bottom: solid 3px #00A4D6;
          cursor: pointer;
        }
      }
    }

    .status-message {
      margin-top: 16px;
      height: 24px;
      color: #424242;
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 24px;
    }
    .event-found {
      color: #8E8E8E;
      font-family: @font-family-main;
      font-size: 12px;
      letter-spacing: 0.1px;
      line-height: 16px;
      text-transform: uppercase;
      margin-top: 32px;
    }

    .grp-button-action {
      margin-top: 16px;
      .item-submit-btn {
        border: 1px solid #00A4D6;
        border-radius: 4px;
        background-color: #f5f5f5;
        float: right;
        padding: 6px 24px;
        span {
          font-weight: 600;
          color: #00A4D6;
          font-size: 16px;
          letter-spacing: 0.1px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
        }
      }
      .item-create-btn {
        background-color: #00A4D6;
        margin-left: 16px;
        float: right;
        padding: 6px 24px;
        span {
          color: #FFFFFF;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
        }
      }
    }

    .no-event-found {
      text-align: center;
      margin: 64px auto 0;
      .text {
        color: #8E8E8E;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        letter-spacing: 0.1px;
        line-height: 16px;
      }
      .item-create-btn {
        background-color: #00A4D6;
        margin-top: 16px;
        padding: 6px 24px;
        span {
          color: #FFFFFF;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          font-family: 'Open Sans', sans-serif;
        }
      }
    }
    .bar-chart-color {
      width: 10px;
      height: 10px;
      float:  left;
      line-height: 15px;
      margin-top: 3px;
    }

    .bar-chart-text {
      float:  left;
      margin-left:  8px;
      line-height: 15px;
    }

    .label-wrapper {
      height: 20px;
      display: inline-block;
    }
  }

  .event-chart-section {
    margin-top: 41px;
  }
</style>



// WEBPACK FOOTER //
// Reports.vue?cf14ba8c